import { useEffect, useRef, useState } from 'react'
import InputField from '@/components/InputField';
import DropDown from '@/components/DropDown';
import ButtonAdminpanel from '@/components/ButtonAdminpanel';
import { default as ReactSelect } from "react-select";
import BackButton from '@/components/stepper/backbutton';
import SkipButton from '@/components/stepper/skipbutton';
import Choosefile from '@/components/Choosefile';
import uploadPhotos from "@/images/Image _placeholder.svg";
import SmallPopup from '@/components/SmallPopup';
import { connect } from "react-redux";
import { isEmpty, map, size } from "lodash";
import { getHSCodeList, getHSCodeSearchList, getCategories } from "@/actions/defaultDataAction";
import { getSupplierMember, postSupplierProduct, removeSupplierProduct, removeSupplierProductImage } from "@/actions/stepperAction";
import defaultValues from '@/constant/defaultValues';
import errorMessages from "@/constant/errorMessages";
import ScreenLoaderHome from "@/components/common/ScreenLoaderHome";




const MAX_IMAGE_SIZE = 2 * 1024 * 1024; // 2 MB
const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/png", "image/jpg"];

const emptyProduct = () => ({
  id: null,
  product_name: "",
  category: null,
  hs_code: null,
  image: null,
  previewImg: null,
  mediaImgId: null,
});

const emptyErrors = () => ({
  product_name: "",
  category: "",
  hs_code: "",
  image: "",
});

const ProductDetails = (props) => {

  const [member_supplier_id, setSupplierMemberID] = useState(null);
  const { IMAGE_PATH } = defaultValues;

  const [products, setProducts] = useState([emptyProduct(), emptyProduct()]);
  const [errors, setErrors] = useState([emptyErrors(), emptyErrors()]);
  const [formError, setFormError] = useState(""); // top-level "at least one product" error

  const allHsCodesRef = useRef([]);
  const hasHydratedRef = useRef(false); // ensures server->local mapping runs only once per hydration cycle
  const [hscodeList, setHsCodeList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);

  const [smallmodalShow, setSmallModalShow] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [deleteProductId, setDeleteProductId] = useState(null);

  const [smallmodalImageShow, setSmallModalImageShow] = useState(false);
  const [deleteImageId, setDeleteImageId] = useState(null);
  const [deleteImageIndex, setDeleteImageIndex] = useState(null);

  const [showLoader, setShowLoader] = useState(false);

  // Debounce/loading guards so rapid double-clicks can't fire an action twice
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isImageDeleting, setIsImageDeleting] = useState(false);

  const submitTimeoutRef = useRef(null);
  const deleteTimeoutRef = useRef(null);
  const imageDeleteTimeoutRef = useRef(null);

  const [selectIndustry,setSelectIndustry] = useState("");

  const productsRef = useRef(products);
  useEffect(() => {
    productsRef.current = products;
  }, [products]);

  useEffect(() => {
    return () => {
      if (submitTimeoutRef.current) clearTimeout(submitTimeoutRef.current);
      if (deleteTimeoutRef.current) clearTimeout(deleteTimeoutRef.current);
      if (imageDeleteTimeoutRef.current) clearTimeout(imageDeleteTimeoutRef.current);
    };
  }, []);


  const handleProductChange = (index, field, value) => {
    setProducts((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });

    setErrors((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: "" };
      return updated;
    });

    if (formError) setFormError("");
  };

  const handleImgChange = (index, e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate type
    if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
      setErrors((prev) => {
        const updated = [...prev];
        updated[index] = { ...updated[index], image: "Only JPEG, JPG or PNG files are allowed" };
        return updated;
      });
      e.target.value = ""; // reset input so same invalid file can be re-selected after fix
      return;
    }

    // Validate size
    if (file.size > MAX_IMAGE_SIZE) {
      setErrors((prev) => {
        const updated = [...prev];
        updated[index] = { ...updated[index], image: "Max file size is 2 MB" };
        return updated;
      });
      e.target.value = "";
      return;
    }

    setProducts((prev) => {
      const updated = [...prev];
      if (updated[index].previewImg) {
        URL.revokeObjectURL(updated[index].previewImg);
      }
      updated[index] = {
        ...updated[index],
        image: file,
        previewImg: URL.createObjectURL(file),
      };
      return updated;
    });

    setErrors((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], image: "" };
      return updated;
    });
  };



  const handleRemoveImg = (index, id = null) => {
    if (id) {
      setDeleteImageId(id);
      setDeleteImageIndex(index);
      setSmallModalImageShow(true);
    } else {
      setProducts((prev) => {
        const updated = [...prev];
        const target = updated[index];
        if (target?.previewImg && target.previewImg.startsWith("blob:")) {
          URL.revokeObjectURL(target.previewImg);
        }
        updated[index] = {
          ...updated[index],
          image: null,
          previewImg: null,
          fileInputKey: (updated[index].fileInputKey || 0) + 1,
        };
        return updated;
      });
      setErrors((prev) => {
        const updated = [...prev];
        updated[index] = { ...updated[index], image: "" };
        return updated;
      });
    }
  };

  const openDeleteModal = (index, id = null) => {
  //  const productIDs = products.map((product) => product.id);
  //   const hasNullId = Array.isArray(productIDs) &&
  //                     productIDs.length > 0 &&
  //                     productIDs.some((pid) => pid === null || pid === undefined);

  //   if (products.length === 1) {
  //     // e.g. prevent deleting the last remaining product
  //     console.log("Cannot delete: only one product left");
  //   } else {
      setDeleteIndex(index);
      setDeleteProductId(id);
      setSmallModalShow(true);
    // }
    
  };

  // A product is "touched" if the user started filling any of its required fields
  const isProductTouched = (product) =>
    !!(product.product_name?.trim() || product.hs_code);

  const isProductEmpty = (product) =>
    !product.product_name?.trim() &&
    // !product.category &&
    !product.hs_code &&
    !product.image &&
    !product.previewImg;

  const isProductComplete = (product) =>
    !!(product.product_name?.trim() && product.category && product.hs_code);

  const validateProductName = (value) => {
    const productNameRegex = /^[A-Za-z0-9\s\-\/.,&()'+:]{2,150}$/;
    if (!value?.trim()) return "The field is required.";
    if (size(value) > 150) return errorMessages.MAX_LENGTH_150_EXCEEDED;
    if (!productNameRegex.test(value)) return errorMessages.IN_VALID_FIELD_FORMAT;
    return "";
  };

  const validateCategory = (value) => (!value ? "The field is required." : "");

  const validateHsCode = (value) => (!value ? "The field is required." : "");

  const handleFocusOut = (index, field, valueOrEvent) => {
    const value = valueOrEvent && valueOrEvent.target
      ? valueOrEvent.target.value
      : valueOrEvent;

    setErrors((prev) => {
      const updated = prev.map((err, i) => (i === index ? { ...err } : err));

      if (field === "product_name") {
        updated[index].product_name = validateProductName(value);
      }
      if (field === "category") {
        updated[index].category = validateCategory(value);
      }
      if (field === "hs_code") {
        updated[index].hs_code = validateHsCode(value);
      }

      return updated;
    });
  };

  const handleCategoryBlur = (index) => {
    handleFocusOut(index, 'category', productsRef.current[index]?.category);
  };

  const handleHsCodeBlur = (index) => {
    handleFocusOut(index, 'hs_code', productsRef.current[index]?.hs_code);
  };


  const validateProducts = () => {
    const nextErrors = products.map((product) => {
    const fieldErrors = emptyErrors();
    if (isProductTouched(product)) {
      fieldErrors.product_name = validateProductName(product.product_name);
      fieldErrors.category = validateCategory(product.category);
      fieldErrors.hs_code = validateHsCode(product.hs_code);
    }
    return fieldErrors;
  });

  const hasFieldErrors = nextErrors.some(
    (e) => e.product_name || e.category || e.hs_code || e.image
  );

  const anyComplete = products.some((product) => isProductComplete(product));

  let topError = "";
  if (!anyComplete && !hasFieldErrors) {
    topError = "Please fill in at least one product.";
  }

  setErrors(nextErrors);
  setFormError(topError);

  return !hasFieldErrors && anyComplete;
};



  const getSubmittableProducts = () =>
    products.map((product) => ({
      ...product,
      product_name: product.product_name?.trim() ?? "",
      category: product.category && typeof product.category === 'object'
      ? product.category
      : getCategoryOption(product.category),
    }));


  const mapServerProductsToLocal = (rows) => {
    const logoUrl = IMAGE_PATH.BASE_URL + "/member_products/";

    const mapped = rows.map((pro) => {
      const photoDetail = pro.product_thumb_media?.[0]?.photo_detail;

      let hsCodeFound = hscodeList.find((h) => String(h.value) === String(pro.hs_code_id));

      if(!hsCodeFound) {
        if(!isEmpty(pro.hs_code)) {
          let tmphscodeList = [...hscodeList];
          hsCodeFound = {
            label: pro.hs_code.code,
            value: pro.hs_code.id
          }

          tmphscodeList.push(hsCodeFound);
          setHsCodeList(tmphscodeList);
        }
      }

      return {
        id: pro.id,
        product_name: pro.product_name || "",
        category: categoryList.find((c) => String(c.value) === String(pro.category_id)) || null,
        hs_code: hsCodeFound || null,
        image: null,
        previewImg: photoDetail ? logoUrl + photoDetail : null,
        mediaImgId: pro.product_thumb_media?.[0]?.id || null,
      };
    });

    while (mapped.length < 2) {
      mapped.push(emptyProduct());
    }

    return mapped;
  };

  const fetchAndHydrateSupplier = async (supplierId) => {
    if (!supplierId) return;

    try {
      // setShowLoader(true);
      const response = await props.getSupplier(supplierId);
      console.log("API response:", response); // check actual shape/status
       
      if (response?.status === true) {
        const step1 = response.data?.step_1?.member_industry.industy_name;
        
        setSelectIndustry(step1);
        const step2 = response.data?.step_2;
        if (!isEmpty(step2)) {
          const mapped = mapServerProductsToLocal(step2);
          setProducts(mapped);
          setErrors(mapped.map(() => emptyErrors()));
          hasHydratedRef.current = true;
        } else {
          console.log("No step_2 product data in response");
        }
      } else {
        console.log("Status check failed, response.status was:", response?.status);
      }
    } catch (err) {
      console.log("Error =", err);
    }
    //  setShowLoader(false);
  };


  const refreshSupplierData = async () => {
    hasHydratedRef.current = false;
    await fetchAndHydrateSupplier(member_supplier_id);
  };

  const fetchHSCodeBasedOnSearch = async (searchTxt) => {
      if(!isEmpty(searchTxt)) {
        await props.getHSCodeSearch(searchTxt).then((response) => {
          const options = map(response, (hscode) => {
            return {
              value: hscode.id,
              label: hscode.code
            }
          });

          const newHsCodeList = [...hscodeList]; 
          options.forEach(option => {
              if (!newHsCodeList.some(existing => existing.value === option.value)) {
                newHsCodeList.push(option);
              }
          });

          setHsCodeList(newHsCodeList);

        }).catch((err) => {
          console.log("Error ========== ", err);
        })
      }
  }
 
  const handleHsCodeInputChange = (searchTxt) => {
      console.log(" handleHsCodeInputChange >>>>> ", searchTxt);
      if(searchTxt != "") {
        if(size(searchTxt) >= 3) {
          fetchHSCodeBasedOnSearch(searchTxt);
        }
      }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    const isValid = validateProducts();
    if (!isValid) return;

    setIsSubmitting(true);
    setShowLoader(true);
    const submittableProducts = getSubmittableProducts();
    await props
      .addSupplierProducts(member_supplier_id, submittableProducts)
      .then(async (response) => {
        if (response?.status === true) {
          await refreshSupplierData();
          props.onNext();
          return;
        }

        if (response && response.status === 422 && response.errors) {
          console.log("Error", response);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setShowLoader(false);
        submitTimeoutRef.current = setTimeout(() => {
          setIsSubmitting(false);
        }, 600);
      });
     
  };

  const handleConfirmDeleteClick = async () => {
    if (isDeleting) return; // block rapid double-click

    const indexToDelete = deleteIndex;
    const idToDelete = deleteProductId;

    if (indexToDelete === null || indexToDelete === undefined) {
      setSmallModalShow(false);
      return;
    }

    

    setIsDeleting(true);

    try {

      if (idToDelete) {
        const response = await props.deleteSupplierProduct(idToDelete);
        if (response?.status !== true) {
          console.log("Something went wrong");
          return;
        }
      }

      setProducts((prev) => {
        const updated = [...prev];
        const target = updated[indexToDelete];

        if (target?.previewImg && target.previewImg.startsWith("blob:")) {
          URL.revokeObjectURL(target.previewImg);
        }

        if (prev.length > 2) {
          updated.splice(indexToDelete, 1);
        } else {
          updated[indexToDelete] = emptyProduct();
        }
        return updated;
      });

      setErrors((prev) => {
        const updated = [...prev];
        if (prev.length > 2) {
          updated.splice(indexToDelete, 1);
        } else {
          updated[indexToDelete] = emptyErrors();
        }
        return updated;
      });

      setSmallModalShow(false);
      setDeleteIndex(null);
      setDeleteProductId(null);

      if (idToDelete) {
        await refreshSupplierData();
      }
    } catch (err) {
      console.log("Error == ", err);
    } finally {
      deleteTimeoutRef.current = setTimeout(() => {
        setIsDeleting(false);
      }, 600);
    }
  };

  const handleConfirmDeleteImageClick = async () => {
    if (isImageDeleting) return;

    const indexToClear = deleteImageIndex;

    setIsImageDeleting(true);
    try {
      const response = await props.deleteSupplierProductImage(deleteImageId);

      if (response.status === true) {
        if (indexToClear !== null && indexToClear !== undefined) {
          setProducts((prev) => {
            const updated = [...prev];
            const target = updated[indexToClear];
            if (target?.previewImg && target.previewImg.startsWith("blob:")) {
              URL.revokeObjectURL(target.previewImg);
            }
            updated[indexToClear] = {
              ...target,
              image: null,
              previewImg: null,
              mediaImgId: null,
              fileInputKey: (target.fileInputKey || 0) + 1,
            };
            return updated;
          });
        }

        setSmallModalImageShow(false);
        setDeleteImageId(null);
        setDeleteImageIndex(null);

        await refreshSupplierData();

      } else {
        console.log(response?.message || "Something went wrong");
      }
    } catch (err) {
      console.log("Error == ", err);
    } finally {
      imageDeleteTimeoutRef.current = setTimeout(() => {
        setIsImageDeleting(false);
      }, 600);
    }
  };

  useEffect(() => {
    if (!formError) return;
    const timer = setTimeout(() => setFormError(""), 4000);
    return () => clearTimeout(timer);
  }, [formError]);

  useEffect(() => {
    if (props.supplier_id) {
      setSupplierMemberID(props.supplier_id);
    }

    if (
      !hasHydratedRef.current &&
      props.supplier_id &&
      !isEmpty(categoryList) &&
      !isEmpty(hscodeList)
    ) {
      fetchAndHydrateSupplier(props.supplier_id);
    }
  }, [props.supplier_id, categoryList, hscodeList]);


  useEffect(() => {
  const fetchDictionaries = async () => {
    try {
      const hsRes = await props.getHSCodeList();
      if (!isEmpty(hsRes)) {
        const opts = map(hsRes, (v) => ({ label: v.code, value: v.id }));
        allHsCodesRef.current = opts;
        setHsCodeList(opts);
      }
    } catch (err) {
      console.error(err);
    }

    try {
      const catRes = await props.getCategories();
      if (!isEmpty(catRes)) {
        const opts = map(catRes, (v) => ({
          label: v.category_name,
          rawLabel: v.category_name,
          value: v.id,
        }));

        if (selectIndustry) {
          const matched = opts.filter(
            (o) => String(o.rawLabel) === String(selectIndustry)
          );
          let result;
            if (matched.length > 0) {
              result = matched;
            } else {
              result = opts
                .filter((o) => String(o.rawLabel) === 'Other')
                .map((o) => ({ ...o, label: `Other (${selectIndustry})` }));
            }
          setCategoryList(result);
          
        } else {
          setCategoryList(opts);
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  fetchDictionaries();
}, [selectIndustry]);


  useEffect(() => {
    if (!selectIndustry || categoryList.length === 0) return;

    const selected = categoryList.find(
      (o) => String(o.label) === String(selectIndustry) || String(o.label) === 'Other'
    );
    if (!selected) return;

    setProducts((prev) => {
      // skip the update if everything is already set (avoids needless re-renders)
      if (prev.every((p) => String(p.category) === String(selected.value) || String(p.category) === 'Other')) {
        return prev;
      } 
      return prev.map((p) => ({ ...p, category: selected.value }));
    });
  }, [categoryList, selectIndustry, products.length]);

  const getCategoryOption = (cat) => {
    if (cat === undefined || cat === null || cat === '') return null;
    const key = typeof cat === 'object' ? cat.value ?? cat.id : cat;
    return (
      categoryList.find(
        (o) =>
          String(o.value) === String(key) ||
          String(o.label) === String(key)
      ) || null
    );
  };

  console.log("===============selectIndustry------------------",selectIndustry);
  

  return (
    <>
      {showLoader && <ScreenLoaderHome />}
      <form onSubmit={handleSubmit} className='stepper-form'>
        <div className='product-details-wrape'>
          <div className='section-header skip-header'>
            <div className="section-content">
              <h2>Showcase Products</h2>
              <p>
                Present your products professionally and attract potential buyers worldwide.
              </p>
            </div>
            {/* <SkipButton onClick={onNext}/> */}

          </div>

          {products.map((product, index) => (
            <div key={index}>
              <div className="d-flex justify-content-end align-items-center product-delete-wrape">
                
              {formError && index == 0 && (
                <div className="alert alert-danger alert-dismissible fade show form-alert" role="alert">
                {formError}
                 <button type="button" className="btn-close" onClick={() => setFormError("")} aria-label="Close"></button>
                 </div>
               )}
               
                {(product?.id) && (
                  <button
                    type="button"
                    className="product-delete-btn"
                    onClick={() => openDeleteModal(index, product?.id)}
                  >
                    <i className="fa-regular fa-trash-can"></i>
                    Delete
                  </button>
                )}
              </div>

              <div className='row'>
                <div className="col-xl-4 py-2">
                  <label className="profile-text">
                    Product {index + 1}<span className="text-danger"> *</span>
                  </label>
                  <div className="d-flex">
                    <div className="w-100">
                      <InputField
                        placeholder="Enter your product name"
                        className="input-error-border"
                        autoComplete="off"
                        value={product.product_name}
                        name="product_name"
                        onChange={(e) => handleProductChange(index, 'product_name', e.target.value)}
                        onBlur={(e) => handleFocusOut(index, 'product_name', e)}
                        
                      />
                      {errors[index]?.product_name && (
                        <span className="invalid-feedback text-danger" style={{ display: "block" }}>
                          {errors[index].product_name}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 py-2">
                  <label className="profile-text">
                    Product Category<span className="text-danger"> *</span>
                  </label>
                  <DropDown
                    className="input-error-border"
                    name="category"
                    options={categoryList}
                    // value={product.category}
                     value={getCategoryOption(product.category)}
                    // onChange={(val) => handleProductChange(index, 'category', val)}
                     onChange={(opt) =>
                      handleProductChange(index, 'category', opt?.value ?? '')
                    }
                    onBlur={() => handleCategoryBlur(index)}
                    placeholder="Select Product Category"
                    menuPlacement="bottom"
                    menuPortalTarget={document.body}
                    isDisabled={true}
                  />
                  {errors[index]?.category && (
                    <span className="invalid-feedback text-danger" style={{ display: "block" }}>
                      {errors[index].category}
                    </span>
                  )}
                </div>

                <div className="col-xl-4 py-2">
                  <label className="profile-text">
                    Product HSN Code<span className="text-danger"> *</span>
                  </label>
                  <ReactSelect
                    options={hscodeList}
                    value={product.hs_code}
                    onChange={(val) => handleProductChange(index, 'hs_code', val)}
                    onBlur={() => handleHsCodeBlur(index)}
                    classNamePrefix="react-select"
                    placeholder="Select HSN Code"
                    noOptionsMessage={() => "No HSN Code Found"}
                    menuPortalTarget={document.body}
                    onInputChange={handleHsCodeInputChange}
                  />
                  {errors[index]?.hs_code && (
                    <span className="invalid-feedback text-danger" style={{ display: "block" }}>
                      {errors[index].hs_code}
                    </span>
                  )}
                </div>
              </div>

              <div className=" row py-3">
                <div className='col-md-6'>
                  <label className='profile-text'>Upload Product Photo</label>
                  <Choosefile
                    key={`product-image-${index}-${product.fileInputKey}`}
                    className={`form-control choose-pdf`}
                    type="file"
                    accept="image/jpeg, image/png, image/jpg"
                    onChange={(e) => handleImgChange(index, e)}
                  />
                  <p className='upload-info'>Allowed JPEG, JPG or PNG. Max size of 2 MB</p>
                  {errors[index]?.image && (
                    <span className="invalid-feedback text-danger" style={{ display: "block" }}>
                      {errors[index].image}
                    </span>
                  )}
                </div>

                <div className='col-md-6'>
                  <div className="d-flex upload-img position-relative">
                    {product.previewImg ? (
                      <>
                        <img
                          src={product.previewImg}
                          alt="preview"
                          id="pdf-img"
                        />
                        <button
                          type="button"
                          className="pdf-close"
                          onClick={() => handleRemoveImg(index, product.mediaImgId)}
                        >
                          <i className="fa-regular fa-trash-can text-danger"></i>
                        </button>
                      </>
                    ) : (
                      <img
                        src={uploadPhotos}
                        alt="no-img"
                        id="pdf-img"
                        className="contactUploadImg"
                      />
                    )}
                  </div>
                </div>
              </div>

             {index < size(products) - 1 && (
              <div className="text-end d-flex justify-content-between align-items-center border-bottom mt-4 mb-2"></div>
              )}
            </div>
          ))}

          <div className='profile-button border-top'>
            <BackButton className="mt-3 mx-3" type="submit" onClick={props.onPrev} disabled={isSubmitting}>
              Back
            </BackButton>
            {/* <ButtonAdminpanel className="mt-3 " type="submit" onClick={onNext}>
                        Continue
                      </ButtonAdminpanel> */}
            <ButtonAdminpanel className="mt-3 " type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Continue to Choose Plan" : "Continue to Choose Plan"}
            </ButtonAdminpanel>
          </div>

        </div>
      </form>


      <SmallPopup
        title="Delete Product"
        smallmodalShow={smallmodalShow}
        setSmallModalShow={setSmallModalShow}
        onSubmit={handleConfirmDeleteClick}
        closeButtonLabel="Cancel"
        okButtonLabel="Delete"
      >
        <div className='row my-3'>
          <div className="col-md-12 p-0">Are you sure you want to delete ?</div>
        </div>
      </SmallPopup>

      <SmallPopup
        title="Delete Image"
        smallmodalShow={smallmodalImageShow}
        setSmallModalShow={setSmallModalImageShow}
        onSubmit={handleConfirmDeleteImageClick}
        closeButtonLabel="Cancel"
        okButtonLabel="Delete"
      >
        <div className='row my-3'>
          <div className="col-md-12 p-0">Are you sure you want to delete ?</div>
        </div>
      </SmallPopup>


    </>
  )
}

const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {
    getHSCodeList: () => dispatch(getHSCodeList()),
    getHSCodeSearch: (search_txt) => dispatch(getHSCodeSearchList(search_txt)),
    getCategories: () => dispatch(getCategories()),
    getSupplier: (supplier_id) => dispatch(getSupplierMember(supplier_id)),
    addSupplierProducts: (member_id, formData) => dispatch(postSupplierProduct(member_id, formData)),
    deleteSupplierProduct: (product_id) => dispatch(removeSupplierProduct(product_id)),
    deleteSupplierProductImage: (product_id) => dispatch(removeSupplierProductImage(product_id)),

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetails);
